export type RowRegistrationStatus = 'incomplete' | 'done';

export const getIconClassForRegistrationStatus = (status: RowRegistrationStatus): string => {
    return status === 'done'
        ? 'fa-solid fa-circle color-success'
        : status === 'incomplete'
          ? 'fa-solid fa-circle-half color-warning'
          : '';
};
